export default "__VITE_ASSET__MLlpXnLn__"